export default $localityModal => {
  const getOpenModal = () => $localityModal.openModal
  const getClickedBy = () => $localityModal.clickedBy

  return { getOpenModal, getClickedBy }
}
